import React,{ 
    useState, 
    useRef, 
    useEffect, 
    forwardRef, 
    useImperativeHandle 
} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFloppyDisk, faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import Select from 'react-select'
import Tagify from "@yaireo/tagify";
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/themes/material_blue.css';
// ==================== component import ================== //
import { specialCharacterValidate } from '../../../../../../../../../component/common/Helper';
import AlertMessage from '../../../../../../../../../component/common/AlertMessage';
import ValidationMessage from '../../../../../../../../../component/common/ValidationMessage';
import ButtonLoader from '../../../../../../../../../component/common/ButtonLoader';

const AttributeForm = forwardRef((props, ref) => {
    const {
        formValidateError,
        attributeFormSave,
        updateAttributeState,
        formActionType,
        isButtonLoader
    } = props;

    const dataTypeOptions = [
        { label: 'Alphanumeric', value: 'Alphanumeric' },
        { label: 'Boolean', value: 'Boolean' },
        { label: 'Currency', value: 'Currency' },
        { label: 'dateTime', value: 'dateTime' },
        { label: 'Time', value: 'Time' },
        { label: 'Float', value: 'Float' },
        { label: 'Integer', value: 'Integer' },
        { label: 'List', value: 'List' },
        { label: 'nonNegativeInteger', value: 'nonNegativeInteger' },
        { label: 'String', value: 'String' },
    ];

    const entitiesTagify = useRef(null);
    const tagifyRef = useRef(null);
    useEffect(() => {
        if (entitiesTagify.current) {
            tagifyRef.current = new Tagify(entitiesTagify.current, {
                duplicates: true,
                enforceWhitelist: false,
                callbacks: {
                    add: (e) => {
                        const newTag = e.detail.data.value;
                        const occurrences = tagifyRef.current.value.filter(
                            tag => tag.value === newTag
                        ).length;
                        if (occurrences > 1) {
                            tagifyRef.current.removeTag(e.detail.tag);
                        }
                    }
                }
            });
        }
        return () => {
            if (tagifyRef.current) {
                tagifyRef.current.destroy();
            }
        };
    },[]);

    const _tagifyRef = useRef(null);
    const listItemTagify = useRef(null)
    useEffect(() => {
        if (listItemTagify.current) {
            _tagifyRef.current = new Tagify(listItemTagify.current);
        }
        return () => {
            if (_tagifyRef.current) {
                _tagifyRef.current.destroy();
            }
        };
    });

    const [ attributeFormError, setAttributeFormError ] = useState({});
    const [ attributeFormData, setAttributeFormData ] = useState({
        attribute : '',
        validation_type : null,
        confirmation : null,
        entities : '',
        data_type : null,
        min_alphanumeric: '',
        max_alphanumeric: '',
        min_nonNegativeInteger: '',
        max_nonNegativeInteger: '',
        min_currency : '',
        max_currency : '',
        select_boolean: null,
        min_integer : '',
        max_integer : '',
        time_start_date : '',
        time_end_date : '',
        start_time: '',
        end_time: '',
        min_float : '',
        max_float : '',
        money_currency : null,
        min_string : '',
        max_string : '',
        max_validation_attempts: '',
        list_item : '',
        utter_actionname_attribute: '',
    });


    const validateField = (name, value) => {

        let error = "";
        if (name === "attribute") {
            if (!value) {
                error = "Attribute is required.";
            }
        }
        if (name === "validation_type") {
            if (!value ) {
                error = "Validation type is required.";
            }
        }
        if (name === "confirmation") {
            if (!value) {
                error = "Confirmation is required.";
            }
        }
        if(selectDataType === 'Integer'){
            if (name === "min_integer") {
                if (!value) {
                    error = "Min & max integer length is required.";
                }
            }
            if (name === "max_integer") {
                if (!value) {
                    error = "Min & max integer length is required.";
                }
            }
            const minInteger = name === "min_integer" ? Number(value) : Number(attributeFormData.min_integer);
	        const maxInteger = name === "max_integer" ? Number(value) : Number(attributeFormData.max_integer);
            if(minInteger && maxInteger){
                if(minInteger > maxInteger){
                    error = "Min value must be smaller than Max value.";
                }
            }
        }
        else if(selectDataType === 'nonNegativeInteger'){
            if (name === "min_nonNegativeInteger") {
                if (!value) {
                    error = "Min & max range is required.";
                }
            }
            if (name === "max_nonNegativeInteger") {
                if (!value) {
                    error = "Min & max range is required.";
                }
            }
            const minNonNegetiveInteger = name === "min_nonNegativeInteger" ? Number(value) : Number(attributeFormData.min_nonNegativeInteger);
	        const maxNonNegetiveInteger = name === "max_nonNegativeInteger" ? Number(value) : Number(attributeFormData.max_nonNegativeInteger);
            if(minNonNegetiveInteger && maxNonNegetiveInteger){
                if(minNonNegetiveInteger > maxNonNegetiveInteger){
                    error = "Min value must be smaller than Max value.";
                }
            }
        }
        else if(selectDataType === 'Alphanumeric'){
            if (name === "min_alphanumeric") {
                if (!value) {
                    error = "Min & max range is required.";
                }
            }
            if (name === "max_alphanumeric") {
                if (!value) {
                    error = "Min & max range is required.";
                }
            }
            const minAlphanumeric = name === "min_alphanumeric" ? Number(value) : Number(attributeFormData.min_alphanumeric);
            const maxAlphanumeric = name === "max_alphanumeric" ? Number(value) : Number(attributeFormData.max_alphanumeric);
            if(minAlphanumeric && maxAlphanumeric){
                if(minAlphanumeric > maxAlphanumeric){
                    error = "Min value must be smaller than Max value.";
                }
            }
        }
        else if(selectDataType === 'Currency'){
            if (name === "money_currency") {
                if (!value) {
                    error = "Money currency is required.";
                }
            }
            if (name === "min_currency") {
                if (!value) {
                    error = "Min & max range is required.";
                }
            }
            if (name === "max_currency") {
                if (!value) {
                    error = "Min & max range is required.";
                }
            }
            const minCurrency = name === "min_currency" ? Number(value) : Number(attributeFormData.min_currency);
	        const maxCurrency = name === "max_currency" ? Number(value) : Number(attributeFormData.max_currency);
            if(minCurrency && maxCurrency){
                if(minCurrency > maxCurrency){
                    error = "Min value must be smaller than Max value.";
                }
            }
        }
        else if(selectDataType === 'Float'){
            if (name === "min_float") {
                if (!value) {
                    error = "Min & max float length is required.";
                }
            }
            if (name === "max_float") {
                if (!value) {
                    error = "Min & max float length is required.";
                }
            }
            const minFloat = name === "min_float" ? Number(value) : Number(attributeFormData.min_float);
	        const maxFloat = name === "max_float" ? Number(value) : Number(attributeFormData.max_float);
            if(minFloat && maxFloat){
                if(minFloat > maxFloat){
                    error = "Min value must be smaller than Max value.";
                }
            }
        }
        else if(selectDataType === 'dateTime'){
            if (name === "time_start_date") {
                if (!value) {
                    error = "Time start & end date is required.";
                }
            }
            if (name === "time_end_date") {
                if (!value) {
                    error = "Time start & end date is required.";
                }
            }
            const timeStart = name === "time_start_date" ? value : attributeFormData.time_start_date;
            const timeEnd = name === "time_end_date" ? value : attributeFormData.time_end_date;
            if (timeStart && timeEnd) {
                const start = new Date(timeStart);
                const end = new Date(timeEnd);
                if (start > end) {
                    error = "Start date must be earlier than or equal to End date.";
                }
            }
        }
        else if(selectDataType === 'Time'){
            if (name === "start_time") {
                if (!value) {
                    error = "Start & end time is required.";
                }
            }
            if (name === "end_time") {
                if (!value) {
                    error = "Start & end time is required.";
                }
            }
        }
        else if( selectDataType === 'String'){
            if (name === "min_string") {
                if (!value) {
                    error = "Min & max string length is required.";
                }
            }
            if (name === "max_string") {
                if (!value) {
                    error = "Min & max string length is required.";
                }
            }
            const minString = name === "min_string" ? Number(value) : Number(attributeFormData.min_string);
	        const maxString = name === "max_string" ? Number(value) : Number(attributeFormData.max_string);
            if(minString && maxString){
                if(minString > maxString){
                    error = "Min value must be smaller than Max value.";
                }
            }
        }
        if (name === "utter_actionname_attribute") {
            if (!value) {
                error = "Attribute utterance is required.";
            }
        }
        return error;
    }

    const [ selectDataType , setSelectDataType ] = useState('');

    const attributeInputOnChange = (selectedOption, actionMeta) => {

        if (actionMeta?.name) {
            // ------- manage select field --------- //
            const { name } = actionMeta;
            if(name === 'data_type'){
                if(selectedOption ){
                    setSelectDataType(selectedOption.value)
                }
                else{
                    setSelectDataType('')
                }
            }
            if( name === 'time_start_date' || name === 'time_end_date' ){
                const [date] = selectedOption;
                if(date){
                    setAttributeFormData((prevData) => ({
                        ...prevData,
                        [name]: date ? date.toISOString() : '',
                    }));
                    const fieldError = validateField(name, date);
                    setAttributeFormError((prevErrors) => ({
                        ...prevErrors,
                        [name]: fieldError,
                    }));
                }
                else{
                    setAttributeFormData((prevData) => ({
                        ...prevData,
                        [name]: '',
                    }));
                    const fieldError = validateField(name, '');
                    setAttributeFormError((prevErrors) => ({
                        ...prevErrors,
                        [name]: fieldError,
                    }));
                }
            }
            else{
                setAttributeFormData((prevData) => ({
                    ...prevData,
                    [name]: selectedOption,
                }));
                const fieldError = validateField(name, selectedOption);
                setAttributeFormError((prevErrors) => ({
                    ...prevErrors,
                    [name]: fieldError,
                }));
            }
        }
        else if(selectedOption?.target){
            // ----- manage input field -------- //
            const { name, value } = selectedOption.target;
            if(
                name === 'min_integer' ||
                name === 'max_integer' ||
                name === 'min_string' ||
                name === 'max_string' ||
                name === 'max_validation_attempts' ||
                name === 'min_float' ||
                name === 'max_float' ||
                name === 'min_alphanumeric' ||
                name === 'max_alphanumeric' ||
                name === 'min_currency' ||
                name === 'max_currency'

            ){
                let isValid = false;
                if (name === 'min_float' || name === 'max_float') {
                    isValid = /^[\d.%]*$/.test(value);
                }
                else{
                    isValid = /^\d*$/.test(value);
                }
                if (isValid) {
                    setAttributeFormData((prevData) => ({
                        ...prevData,
                        [name]: value,
                    }));
                }
            }
            else{
                let newVal = value
                const fieldsToValidate = ['attribute'];
                if (fieldsToValidate.includes(name)) {
                    newVal = specialCharacterValidate(newVal);
                }
                setAttributeFormData((prevData) => ({
                    ...prevData,
                    [name]: newVal,
                }));
            }
            const fieldError = validateField(name, value);
            setAttributeFormError((prevErrors) => ({
                ...prevErrors,
                [name]: fieldError,
            }));
        }
    }

    const AttributeSave = (e) => {
        e.preventDefault();
        const newErrors = {};
        for (const key in attributeFormData) {
            newErrors[key] = validateField(key, attributeFormData[key]);
        }
        setAttributeFormError(newErrors);
        if (Object.keys(newErrors).every((key) => !newErrors[key])) {
            attributeFormSave(attributeFormData)
        }
    }

    useImperativeHandle(ref, () => ({
        resetForm: () => {
            setAttributeFormData((prevState) => ({
                ...prevState,
                attribute : '',
                validation_type : null,
                confirmation : null,
                entities : '',
                data_type : null,
                min_alphanumeric: '',
                max_alphanumeric: '',
                min_nonNegativeInteger: '',
                max_nonNegativeInteger: '',
                min_currency : '',
                max_currency : '',
                select_boolean: null,
                min_integer : '',
                max_integer : '',
                time_start_date : '',
                time_end_date : '',
                start_time:'',
                end_time:'',
                min_float : '',
                max_float : '',
                money_currency : null,
                min_string : '',
                max_string : '',
                max_validation_attempts:'',
                list_item: '',
                utter_actionname_attribute: '',
            }));
            setSelectDataType('')
        }
    }));


    useEffect(() => {
        if( updateAttributeState.length > 0 ){
            if(formActionType === 'update'){
                let attributeUpdateData = updateAttributeState[0];
                console.log('========== attributeUpdateData =============', attributeUpdateData)
                setAttributeFormData((prevState) => ({
                    ...prevState,
                    attribute: attributeUpdateData.attribute,
                    validation_type: attributeUpdateData.validation_type,
                    confirmation: attributeUpdateData.confirmation,
                    data_type: attributeUpdateData.data_type,
                    min_integer: attributeUpdateData.min_integer,
                    max_integer: attributeUpdateData.max_integer,
                    time_start_date: attributeUpdateData.time_start_date,
                    time_end_date: attributeUpdateData.time_end_date,
                    start_time: attributeUpdateData.start_time,
                    end_time: attributeUpdateData.end_time,
                    min_float: attributeUpdateData.min_float,
                    max_float: attributeUpdateData.max_float,
                    money_currency: attributeUpdateData.money_currency,
                    min_string: attributeUpdateData.min_string,
                    max_string: attributeUpdateData.max_string,
                    max_validation_attempts: attributeUpdateData.max_validation_attempts,
                    utter_actionname_attribute: attributeUpdateData.utter_actionname_attribute,
                    max_nonNegativeInteger: attributeUpdateData.max_nonNegativeInteger,
                    min_nonNegativeInteger: attributeUpdateData.min_nonNegativeInteger,
                    min_alphanumeric: attributeUpdateData.min_alphanumeric,
                    max_alphanumeric: attributeUpdateData.max_alphanumeric,
                    min_currency: attributeUpdateData.min_currency,
                    max_currency: attributeUpdateData.max_currency,
                }));
                setTimeout(() => {
                    if (entitiesTagify.current) {
                        tagifyRef.current.removeAllTags();
                        tagifyRef.current.addTags(attributeUpdateData.entities);
                    }
                }, 100);
                setTimeout(() => {
                    if (listItemTagify.current) {
                        _tagifyRef.current.removeAllTags();
                        _tagifyRef.current.addTags(attributeUpdateData.list_item);
                    }
                }, 200);
                if(attributeUpdateData.select_boolean){
                    attributeInputOnChange(
                        attributeUpdateData.select_boolean, 
                        {action : "select-option",name : "select_boolean"}
                    )
                }
                if(attributeUpdateData.data_type){
                    attributeInputOnChange(
                        attributeUpdateData.data_type, 
                        {action : "select-option",name : "data_type"}
                    )
                }
            }
            else{
                setAttributeFormData({
                    attribute : '',
                    validation_type : null,
                    confirmation : null,
                    entities : '',
                    data_type : null,
                    min_alphanumeric: '',
                    max_alphanumeric: '',
                    min_nonNegativeInteger: '',
                    max_nonNegativeInteger: '',
                    min_currency : '',
                    max_currency : '',
                    select_boolean: null,
                    min_integer : '',
                    max_integer : '',
                    time_start_date : '',
                    time_end_date : '',
                    start_time : '',
                    end_time : '',
                    min_float : '',
                    max_float : '',
                    money_currency : null,
                    min_string : '',
                    max_string : '',
                    max_validation_attempts:'',
                    list_item: '',
                    utter_actionname_attribute: ''
                })
            }
        }
    },[updateAttributeState]);



    const infoPopupData = {
        'add_attribute' : {
            'title' : 'Add attribute',
            'info' : `Attribute is the set of information you should collect. It could be Customer Name like First Name, Last Name. Or phone number, or email, or credit card number etc. Create comprehensive list of all Attributes you may need. You can associate them to relevant services later.`,
        },
        'validation_type' : {
            'title' : 'Validation type',
            'info' : `Choose Optional or Mandatory.`,
        },
        'confirmation' : {
            'title' : 'Confirmation',
            'info' : `Use Confirmation if you need the customer response to be confirmed. For example, you want to cofirm the phone number that the customer has provided.`,
        },
        'attribute_synonyms' : {
            'title' : 'Synonyms',
            'info' : `Enlist all synonyms that go with Attribute. For example, First Name can be "Fname", "F Name" or just "Name"`,
        },
        'data_type' : {
            'title' : 'Data type',
            'info' : `Assign Data Type to each attribute`,
        },
        'max_validation_attempts' : {
            'title' : 'Max validation attempts',
            'info' : `Use this if you opted for Mandatory Validation above. After Max Attempts are exhausted, the Agent will move on to the next query.`,
        },
        'utter_actionname_attribute':{
            'title' : 'Add Attribute Utterance',
            'info' : `This is what the Agent will ask your customer. For example, May I have your phone number?`,
        }
    }

    const infoOpenOnCLick = (param) => {
        props.isInfoOpenHandler({
            type: 'open',
            data: infoPopupData[param]
        })
    }


    return (
        <>

            <div className='row'>
                <div className='col-md-12 mb-5'>
                    <label className="form-label required">
                        Add Attribute
                    </label>
                    <span 
                        className="fs-6 fw-semibold align-self-start cursor-pointer float-end"
                        onClick={(e) => infoOpenOnCLick('add_attribute')}
                    >
                        <FontAwesomeIcon className='fs-5 text-gray-600' icon={faCircleInfo} />
                    </span>
                    <input
                        type="text"
                        className="form-control form-control-solid"
                        placeholder="Enter attribute"
                        name="attribute"
                        onChange={attributeInputOnChange}
                        value={attributeFormData.attribute}
                    />
                    {
                        attributeFormError.attribute &&
                        <ValidationMessage className='text-danger' message ={attributeFormError.attribute}/>
                    }
                </div>
                <div className='col-md-12 mb-5'>
                    <label className="form-label">
                        Synonyms
                    </label>
                    <span 
                        className="fs-6 fw-semibold align-self-start cursor-pointer float-end ms-5"
                        onClick={(e) => infoOpenOnCLick('attribute_synonyms')}
                    >
                        <FontAwesomeIcon className='fs-5 text-gray-600' icon={faCircleInfo} />
                    </span>
                    <span 
                        className="fs-6 fw-semibold text-primary ms-2 float-end">
                        (Press Enter to add each synonym)
                    </span>
                    <input
                        type="text"
                        className="form-control form-control-solid"
                        placeholder="Enter synonyms"
                        ref={entitiesTagify}
                        name="entities"
                        onChange={attributeInputOnChange}
                        value={attributeFormData.entities}
                    />
                </div>
                <div className='col-md-12 mb-5'>
                    <label className="form-label required">
                        Validation Type
                    </label>
                    <span 
                        className="fs-6 fw-semibold align-self-start cursor-pointer float-end"
                        onClick={(e) => infoOpenOnCLick('validation_type')}
                    >
                        <FontAwesomeIcon className='fs-5 text-gray-600' icon={faCircleInfo} />
                    </span>
                    <Select
                        className='react-select-styled react-select-solid' 
                        classNamePrefix='react-select' 
                        options={[
                            {label : 'Optional', value : 'Optional'},
                            {label : 'Mandatory', value : 'Mandatory'},
                        ]}
                        placeholder='Select an option'
                        name="validation_type"
                        onChange={attributeInputOnChange}
                        value={attributeFormData.validation_type}
                    />
                    {
                        attributeFormError.validation_type &&
                        <ValidationMessage className='text-danger' message ={attributeFormError.validation_type}/>
                    }
                </div>
                <div className='col-md-12 mb-5'>
                    <label className="form-label required">
                        Confirmation
                    </label>
                    <span 
                        className="fs-6 fw-semibold align-self-start cursor-pointer float-end"
                        onClick={(e) => infoOpenOnCLick('confirmation')}
                    >
                        <FontAwesomeIcon className='fs-5 text-gray-600' icon={faCircleInfo} />
                    </span>
                    <Select 
                        className='react-select-styled react-select-solid' 
                        classNamePrefix='react-select' 
                        options={[
                            {label : 'Yes', value : 'Yes'},
                            {label : 'No', value : 'No'},
                        ]}
                        placeholder='Select an option' 
                        name="confirmation"
                        onChange={attributeInputOnChange}
                        value={attributeFormData.confirmation}
                    />
                    {
                        attributeFormError.confirmation &&
                        <ValidationMessage className='text-danger' message ={attributeFormError.confirmation}/>
                    }
                </div>
                <div className={`col-md-${selectDataType === 'Currency' ? '6' : '12'} mb-5`}>
                    <label className="form-label">
                        Select Data Type
                    </label>
                    <span 
                        className="fs-6 fw-semibold align-self-start cursor-pointer float-end ms-5"
                        onClick={(e) => infoOpenOnCLick('data_type')}
                    >
                        <FontAwesomeIcon className='fs-5 text-gray-600' icon={faCircleInfo} />
                    </span>
                    <Select
                        className='react-select-styled react-select-solid' 
                        classNamePrefix='react-select' 
                        options={dataTypeOptions} 
                        placeholder='Select an option' 
                        isClearable
                        name="data_type"
                        onChange={attributeInputOnChange}
                        value={attributeFormData.data_type}
                    />
                </div>
                {
                    selectDataType === 'Alphanumeric' &&
                    <div className='col-md-12 mb-5'>
                        <label className="form-label required">
                            Range
                        </label>
                        <div className="input-group input-group-solid">
                            <span className="input-group-text">Min</span>
                            <input 
                                type="text" 
                                className="form-control"
                                name="min_alphanumeric"
                                onChange={attributeInputOnChange}
                                value={attributeFormData.min_alphanumeric}
                            />
                            <span className="input-group-text">Max</span>
                            <input 
                                type="text" 
                                className="form-control" 
                                name="max_alphanumeric"
                                onChange={attributeInputOnChange}
                                value={attributeFormData.max_alphanumeric}
                            />
                        </div>
                        {
                            attributeFormError.min_alphanumeric ? (
                                <ValidationMessage
                                    className="text-danger"
                                    message={attributeFormError.min_alphanumeric}
                                />
                            ) : attributeFormError.max_alphanumeric ? (
                                <ValidationMessage
                                    className="text-danger"
                                    message={attributeFormError.max_alphanumeric}
                                />
                            ) : ''
                        }
                    </div>
                }
                {
                    selectDataType === 'nonNegativeInteger' &&
                    <div className='col-md-12 mb-5'>
                        <label className="form-label required">
                            Range
                        </label>
                        <div className="input-group input-group-solid">
                            <span className="input-group-text">Min</span>
                            <input 
                                type="text" 
                                className="form-control"
                                name="min_nonNegativeInteger"
                                onChange={attributeInputOnChange}
                                value={attributeFormData.min_nonNegativeInteger} // min_nonNegativeInteger
                            />
                            <span className="input-group-text">Max</span>
                            <input 
                                type="text" 
                                className="form-control" 
                                name="max_nonNegativeInteger"
                                onChange={attributeInputOnChange}
                                value={attributeFormData.max_nonNegativeInteger}
                            />
                        </div>
                        {
                            attributeFormError.min_nonNegativeInteger ? (
                                <ValidationMessage
                                    className="text-danger"
                                    message={attributeFormError.min_nonNegativeInteger}
                                />
                            ) : attributeFormError.max_nonNegativeInteger ? (
                                <ValidationMessage
                                    className="text-danger"
                                    message={attributeFormError.max_nonNegativeInteger}
                                />
                            ) : ''
                        }
                    </div>
                }
                {
                    selectDataType === 'Integer' && 
                    <div className='col-md-12 mb-5'>
                        <label className="form-label required">
                            Range
                        </label>
                        <div className="input-group input-group-solid">
                            <span className="input-group-text">Min</span>
                            <input 
                                type="text" 
                                className="form-control" 
                                onChange={attributeInputOnChange} 
                                name="min_integer"
                                value={attributeFormData.min_integer}
                            />
                            <span className="input-group-text">Max</span>
                            <input 
                                type="text" 
                                className="form-control" 
                                name="max_integer" 
                                onChange={attributeInputOnChange}
                                value={attributeFormData.max_integer}
                            />
                        </div>
                        {
                            attributeFormError.max_integer ? (
                                <ValidationMessage
                                    className="text-danger"
                                    message={attributeFormError.max_integer}
                                />
                            ) : attributeFormError.min_integer ? (
                                <ValidationMessage
                                    className="text-danger"
                                    message={attributeFormError.min_integer}
                                />
                            ) : ''
                        }
                    </div>
                }
                {
                    selectDataType === 'Float' &&
                    <>
                        <div className='col-md-12 mb-5'>
                            <label className="form-label required">
                                Range
                            </label>
                            <div className="input-group input-group-solid">
                                <span className="input-group-text">Min</span>
                                <input 
                                    type="text" 
                                    className="form-control" 
                                    onChange={attributeInputOnChange} 
                                    name="min_float"
                                    value={attributeFormData.min_float}
                                />
                                <span className="input-group-text">Max</span>
                                <input 
                                    type="text" 
                                    className="form-control" 
                                    name="max_float" 
                                    onChange={attributeInputOnChange}
                                    value={attributeFormData.max_float}
                                />
                            </div>
                            {
                                attributeFormError.min_float ? (
                                    <ValidationMessage
                                        className="text-danger"
                                        message={attributeFormError.min_float}
                                    />
                                ) : attributeFormError.max_float ? (
                                    <ValidationMessage
                                        className="text-danger"
                                        message={attributeFormError.max_float}
                                    />
                                ) : ''
                            }
                        </div>
                    </>
                }
                {
                    selectDataType === 'dateTime' &&
                    <>
                        <div className='col-md-12 mb-5'>
                            <label className="form-label required">
                                Select start and end time
                            </label>
                            <div className="input-group input-group-solid">
                                <span className="input-group-text">Start</span>
                                <Flatpickr
                                    onChange={(dates) => attributeInputOnChange(dates, { name: 'time_start_date' })} 
                                    options={{
                                        dateFormat: 'd-m-Y',
                                    }}
                                    className='form-control form-control-solid'
                                    value={attributeFormData.time_start_date}
                                />
                                <span className="input-group-text">End</span>
                                <Flatpickr
                                    onChange={(dates) => attributeInputOnChange(dates, { name: 'time_end_date' })}
                                    options={{
                                        dateFormat: 'd-m-Y',
                                    }}
                                    className='form-control form-control-solid'
                                    value={attributeFormData.time_end_date}
                                />
                            </div>
                            {
                                attributeFormError.time_start_date ? (
                                    <ValidationMessage
                                        className="text-danger"
                                        message={attributeFormError.time_start_date}
                                    />
                                ) : attributeFormError.time_end_date ? (
                                    <ValidationMessage
                                        className="text-danger"
                                        message={attributeFormError.time_end_date}
                                    />
                                ) : ''
                            }
                        </div>
                    </>
                }

                {
                    selectDataType === 'Time' &&
                    <>
                        <div className='col-md-12 mb-5'>
                            <label className="form-label required">
                                Select start and end time
                            </label>
                            <div className="input-group input-group-solid">
                                <span className="input-group-text">Start</span>
                                <Flatpickr
                                    onChange={(dates, times, instance) => {
                                        attributeInputOnChange(times, { name: "start_time" });
                                    }}
                                    options={{
                                        enableTime: true,      
                                        noCalendar: true,        
                                        dateFormat: "h:i K",     
                                        time_24hr: false, 
                                    }}
                                    className='form-control form-control-solid'
                                    value={attributeFormData.start_time}
                                />
                                <span className="input-group-text">End</span>
                                <Flatpickr
                                    onChange={(dates, times, instance) => {
                                        attributeInputOnChange(times, { name: "end_time" });
                                    }}
                                    options= {{
                                        enableTime: true,
                                        noCalendar: true,
                                        dateFormat: "h:i K",
                                        time_24hr: false,
                                    }}
                                    className='form-control form-control-solid'
                                    value={attributeFormData.end_time}
                                />
                            </div>
                            {
                                attributeFormError.start_time ? (
                                    <ValidationMessage
                                        className="text-danger"
                                        message={attributeFormError.start_time}
                                    />
                                ) : attributeFormError.end_time ? (
                                    <ValidationMessage
                                        className="text-danger"
                                        message={attributeFormError.end_time}
                                    />
                                ) : ''
                            }
                        </div>
                    </>
                }

                {
                    selectDataType === 'String' &&
                    <div className='col-md-12 mb-5'>
                        <label className="form-label required">
                            Range
                        </label>
                        <div className="input-group input-group-solid">
                            <span className="input-group-text">Min</span>
                            <input 
                                type="text" 
                                className="form-control"
                                name="min_string"
                                onChange={attributeInputOnChange}
                                value={attributeFormData.min_string}
                            />
                            <span className="input-group-text">Max</span>
                            <input 
                                type="text" 
                                className="form-control" 
                                name="max_string"
                                onChange={attributeInputOnChange}
                                value={attributeFormData.max_string}
                            />
                        </div>
                        {
                            attributeFormError.min_string ? (
                                <ValidationMessage
                                    className="text-danger"
                                    message={attributeFormError.min_string}
                                />
                            ) : attributeFormError.max_string ? (
                                <ValidationMessage
                                    className="text-danger"
                                    message={attributeFormError.max_string}
                                />
                            ) : ''
                        }
                    </div>
                }
                {
                    selectDataType === 'Currency' &&
                    <>
                        <div className='col-md-6 mb-5'>
                            <label className="form-label required">
                                Select Currency
                            </label>
                            <Select
                                className='react-select-styled react-select-solid' 
                                classNamePrefix='react-select' 
                                options={[
                                    {label : 'US $', value : 'US $'},
                                    {label : 'INR', value : 'INR'},
                                    {label : 'Euro', value : 'Euro'},
                                ]} 
                                placeholder='Select an option' 
                                name="money_currency"
                                onChange={attributeInputOnChange}
                                value={attributeFormData.money_currency}
                            />
                            {
                                attributeFormError.money_currency &&
                                <ValidationMessage className='text-danger' message ={attributeFormError.money_currency}/>
                            }
                        </div>
                        <div className='col-md-12 mb-5'>
                            <label className="form-label required">
                                Range
                            </label>
                            <div className="input-group input-group-solid">
                                <span className="input-group-text">Min</span>
                                <input 
                                    type="text" 
                                    className="form-control" 
                                    onChange={attributeInputOnChange} 
                                    name="min_currency"
                                    value={attributeFormData.min_currency}
                                />
                                <span className="input-group-text">Max</span>
                                <input 
                                    type="text" 
                                    className="form-control" 
                                    name="max_currency" 
                                    onChange={attributeInputOnChange}
                                    value={attributeFormData.max_currency}
                                />
                            </div>
                            {
                                attributeFormError.min_currency ? (
                                    <ValidationMessage
                                        className="text-danger"
                                        message={attributeFormError.min_currency}
                                    />
                                ) : attributeFormError.max_currency ? (
                                    <ValidationMessage
                                        className="text-danger"
                                        message={attributeFormError.max_currency}
                                    />
                                ) : ''
                            }
                        </div>
                        
                    </>
                }
                {
                    selectDataType === 'Boolean' &&
                    <>
                        <div className='col-md-12 mb-5'>
                            <label className="form-label required">
                                Select
                            </label>
                            <Select 
                                className='react-select-styled react-select-solid' 
                                classNamePrefix='react-select' 
                                options={[
                                    {label : 'Yes / No', value : 'Yes / No'},
                                    {label : 'True / False', value : 'True / False'},
                                  
                                ]} 
                                placeholder='Select an option' 
                                name="select_boolean"
                                onChange={attributeInputOnChange}
                                value={attributeFormData.select_boolean}
                            />
                            {
                                attributeFormError.select_boolean &&
                                <ValidationMessage className='text-danger' message ={attributeFormError.select_boolean}/>
                            }
                        </div>
                    </>
                }
                {
                    selectDataType === 'List' &&
                    <div className='col-md-12 mb-5'>
                        <label className="form-label">
                            List Item
                        </label>
                        <span 
                            className="fs-6 fw-semibold text-primary ms-2 float-end">
                            (Press Enter to add each synonym)
                        </span>
                        <input
                            type="text"
                            className="form-control form-control-solid"
                            placeholder="Enter list items"
                            ref={listItemTagify}
                            name="list_item"
                            onChange={attributeInputOnChange}
                            value={attributeFormData.list_item}
                        />
	                </div>
                }
                
                <div className='col-md-12 mb-5'>
                    <label className="form-label">
                        Max Validation Attempts
                    </label>
                    <span 
                        className="fs-6 fw-semibold align-self-start cursor-pointer float-end ms-5"
                        onClick={(e) => infoOpenOnCLick('max_validation_attempts')}
                    >
                        <FontAwesomeIcon className='fs-5 text-gray-600' icon={faCircleInfo} />
                    </span>
                    <input
                        type="text"
                        className="form-control form-control-solid"
                        placeholder="Enter validation attempts"
                        name="max_validation_attempts" 
                        onChange={attributeInputOnChange}
                        value={attributeFormData.max_validation_attempts}
                    />
                </div>

                <div className='col-md-12 mb-5'>
                    <label className="form-label required">
                        Add Attribute Utterance
                    </label>
                    <span 
                        className="fs-6 fw-semibold align-self-start cursor-pointer float-end ms-5"
                        onClick={(e) => infoOpenOnCLick('utter_actionname_attribute')}
                    >
                        <FontAwesomeIcon className='fs-5 text-gray-600' icon={faCircleInfo} />
                    </span>
                    <input
                        type="text"
                        className="form-control form-control-solid"
                        placeholder="Enter attribute utterance"
                        name="utter_actionname_attribute" 
                        onChange={attributeInputOnChange}
                        value={attributeFormData.utter_actionname_attribute}
                    />
                    {
                        attributeFormError.utter_actionname_attribute &&
                        <ValidationMessage className='text-danger' message ={attributeFormError.utter_actionname_attribute}/>
                    }
                </div>

                <div className='col-md-12 text-end mb-5'>
                    {
                        formActionType === 'insert' &&
                        <div 
                            className={`btn btn-dark btn-icon btn-sm ${isButtonLoader ? 'disabled' : ''}`} 
                            onClick={AttributeSave}
                        >
                            {
                                isButtonLoader ?
                                <ButtonLoader/>
                                :
                                <FontAwesomeIcon icon={faFloppyDisk} className='fs-5' />
                            }
                        </div>
                    }
                    {
                        formActionType === 'update' &&
                        <div 
                            className={`btn btn-primary btn-sm ${isButtonLoader ? 'disabled' : ''}`} 
                            onClick={AttributeSave}
                        >
                            {
                                isButtonLoader ? 
                                <ButtonLoader
                                    btnHtml='Please wait...'
                                    className='me-2'
                                />
                                :
                                'Update'
                            }
                        </div>
                    }
                </div>
                {
                    formValidateError?.attribute_setup &&
                    <AlertMessage
                        sub_title = {formValidateError?.attribute_setup}
                        type = 'danger'
                    />
                }
            </div>
        </>
    )
})

export default AttributeForm